import React from 'react'
import { tagAxes } from '@cpsy-rmap-project/tags'
import { DetailedPaper } from '@cpsy-rmap-project/web-core/repositories'
import _ from 'lodash'
import MaterialTable from 'material-table'
import Pill from '../../atoms/Pill'
import { usePaperDetailsModal } from '../../molecules/PaperDetailsModal/hooks'

// NOTE: 拡張する場合などのために改めてtype定義する
type RowData = DetailedPaper

interface Props {
  papers: DetailedPaper[]
}

const commonHeaderStyle: React.CSSProperties = {
  fontSize: '0.8rem'
}

const commonCellStyle: React.CSSProperties = {
  fontSize: '0.85rem'
}

const truncatedRender = (key: keyof RowData, length: number) => (rowData: RowData) =>
  (
    <span style={{ wordBreak: 'break-word' }}>
      {_.truncate(rowData[key], {
        length /* 最大文字数 */
      })}
    </span>
  )

// eslint-disable-next-line max-lines-per-function
const Component: React.FC<Props> = ({ papers }) => {
  const { handlePaperDetailsModalOpen } = usePaperDetailsModal()

  const columnsOptions = React.useMemo(
    () =>
      _.flatten(
        tagAxes.map(tagAxis => {
          const depth = tagAxis.enableToInclueOtherTagToTopLevel ? tagAxis.depth - 1 : tagAxis.depth
          return new Array(depth).fill(undefined).map((v, i) => ({
            title: tagAxis.name + (depth === 1 ? '' : ` (lv.${i + 1})`),
            field: `details.${tagAxis.id}[${i}].tagNames`,
            headerStyle: {
              minWidth: '8rem',
              ...commonHeaderStyle
            },
            cellStyle: {
              minWidth: '8rem',
              textAlign: 'center' as const,
              ...commonCellStyle
            },
            render: (rowData: RowData) => {
              if (!rowData.details[tagAxis.id][i]) {
                return <></>
              }
              return (
                <>
                  {rowData.details[tagAxis.id][i].tagIds.map(tagId => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={rowData.id + tagAxis.id + i + tagId}>
                      <Pill id={tagId} isInlineBlock clickable />
                    </div>
                  ))}
                </>
              )
            }
          }))
        })
      ),
    []
  )

  return (
    <>
      <MaterialTable<RowData>
        columns={[
          {
            title: 'Title',
            field: 'title',
            headerStyle: {
              minWidth: '16rem',
              ...commonHeaderStyle
            },
            cellStyle: {
              minWidth: '16rem',
              ...commonCellStyle
            },
            render: truncatedRender('title', 150)
          },
          {
            title: 'Authors',
            field: 'authors',
            headerStyle: {
              minWidth: '16rem',
              ...commonHeaderStyle
            },
            cellStyle: {
              minWidth: '16rem',
              ...commonCellStyle
            },
            render: truncatedRender('authors', 150)
          },
          {
            title: 'Year',
            field: 'year',
            type: 'numeric',
            headerStyle: {
              ...commonHeaderStyle
            },
            cellStyle: {
              ...commonCellStyle
            }
          },
          {
            title: 'Cited Count',
            field: 'citedCount',
            type: 'numeric',
            defaultSort: 'desc',
            headerStyle: {
              ...commonHeaderStyle
            },
            cellStyle: {
              ...commonCellStyle
            }
          },
          {
            title: 'Journal',
            field: 'journal',
            headerStyle: {
              minWidth: '12rem',
              ...commonHeaderStyle
            },
            cellStyle: {
              minWidth: '12rem',
              ...commonCellStyle
            },
            render: truncatedRender('journal', 100)
          },
          ...columnsOptions
        ]}
        data={papers}
        title=""
        options={{
          // 1ページあたりの表示
          pageSize: 10,
          // 選択可能な表示数
          pageSizeOptions: [10, 50, 100, 500, 1000],
          // バー固定
          // maxBodyHeight: 600,
          // Delete等アクションは一番右に
          actionsColumnIndex: -1,
          // 検索機能
          search: false,
          // ソート機能
          sorting: true,
          // エクスポート機能
          exportButton: true,
          // フィルタリング機能
          filtering: false
          // グルーピング機能
          // grouping: true
        }}
        onRowClick={(event, rowData) => {
          handlePaperDetailsModalOpen(rowData)
        }}
      />
    </>
  )
}

export default Component
